<template>
  <div
    class="wrapper"
    :class="getClasses"
    @click.stop="onChange"
  >
    <image-field
      :src="getIcon"
      max-width="20"
      height="20"
      contain
      :disabled="disabledValue"
      class="mr-2"
      :class="getClasses"
    />

    <slot>{{ labelValue }}</slot>
  </div>
</template>
<script>
import ImageField from './ImageField.vue'

const CHECKED_ICON_SRC = '/img/icons/checkbox-checked-icon.svg'
const BASE_ICON_SRC = '/img/icons/checkbox-base-icon.svg'
const INDETERMINATE_ICON_SRC = '/img/icons/checkbox-partially-checked-icon.svg'
const DEFAULT_EMPTY_VALUE = ''
export default {
  name: 'CheckboxComponent',

  components: {
    ImageField
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'onChange'
  ],

  data () {
    return {
      modelValue: false
    }
  },

  computed: {
    labelValue () {
      return this.label || this.config?.label || DEFAULT_EMPTY_VALUE
    },

    disabledValue () {
      return this.disabled || this.config?.disabled || false
    },

    indeterminateValue () {
      return this.indeterminate || this.config?.indeterminate || false
    },

    getIcon () {
      if (this.src) {
        return this.src
      }

      if (this.indeterminateValue) {
        return INDETERMINATE_ICON_SRC
      }

      return this.modelValue
        ? CHECKED_ICON_SRC
        : BASE_ICON_SRC
    },

    getClasses () {
      return {
        disabled: this.disabledValue
      }
    }
  },

  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.modelValue = !!val
      }
    },

    'config.value': {
      immediate: true,
      handler (val) {
        if (val !== undefined) {
          this.modelValue = !!val
        }
      }
    }
  },

  methods: {
    onChange () {
      // A half-ticked box stands for a selection that is already part-way made, so
      // pressing it clears that selection rather than completing it - and the box goes
      // empty with it. Flipping its own value there would have reported the opposite
      // and left it drawn as ticked, since the value it was given never changed.
      this.modelValue = this.indeterminateValue ? false : !this.modelValue
      const { onChange } = this.config || {}

      this.$emit('onChange', {
        value: this.modelValue
      })

      if (typeof onChange === 'function') {
        onChange({
          value: this.modelValue
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #111827;
}

.wrapper:hover {
  cursor: pointer;
}

.disabled {
  color: rgba(0,0,0,.38) !important;
  pointer-events: none;
}

.disabled:hover {
  cursor: default;
}
</style>
